
import mixins from "@/@core/mixins";
import MixinsUtilities from "@/@modules/fseg/services/MixinsUtilities";
import { Auth } from "@/@core";
import { ConfigToolbar, MainMenuItem } from "@/@shell/components/BaseToolbar/interfaces/Toolbar";
// import { GraphqlService } from "@/@modules/fseg/services/GraphqlService";
import { worker } from "@/@modules/fseg/services/store/worker";

export default mixins(MixinsUtilities).extend({
  data() {
    return {
      drawer: true,
      config: {
        id: "menu.fseg",
        pushToPage: "home",
        routes: [
          {
            paths: ["/worker/signaletic"],
            getItem: (): MainMenuItem => {
              return {
                id: this.$route.query.id as string,
                path: this.$route.fullPath,
              };
            },
            getLabel: (): string => {
              // TODO: call here GraphqlService.getWorkerSsin ???
              return worker.data ? this.getFormattedSsin(worker.data.nativeWorker.ssin, [6, 10], "-") : "";
            },
            getPopup: (): string => {
              return `${this.$t("fseg.signaletic.title")}: worker ${this.$route.query.id as string}`;
            },
          },
        ],
        isDynamicMenuShown: Auth.isInRole("AGENT"),
      } as ConfigToolbar,
    };
  },
  computed: {
    hasAgentRole(): boolean {
      return Auth.isInRole("AGENT");
    },
    menu(): MainMenuItem[] {
      return [
        {
          id: "toolbarMenu_home",
          path: "/",
          icon: "fa fa-home",
        },
        {
          id: "toolbarMenu_search",
          auth: "AGENT",
          path: "/search",
          label: this.$tc("fseg.toolbarMenu.agent.search"),
        },
        {
          id: "toolbarMenu_signatures",
          auth: "AGENT",
          path: "/signatures",
          label: this.$tc("fseg.toolbarMenu.agent.signatures"),
        },
        {
          id: "toolbarMenu_worker_signaletic",
          auth: "WORKER",
          path: "/worker/signaletic",
          label: this.$tc("fseg.toolbarMenu.worker.signaletic"),
        },
        {
          id: "toolbarMenu_worker_documents",
          auth: "WORKER",
          path: "/documents",
          label: this.$tc("fseg.toolbarMenu.worker.documents"),
        },
      ];
    },
  },
});
